import React from "react";
import PropTypes from "prop-types";
import { HashRouter as Router, Route } from "react-router-dom";

function withRouterV4(WrappedComponent) {
  return class extends React.Component {
    static propTypes = {
      location: PropTypes.string,
    };

    constructor(props, context) {
      super(props, context);
    }
    render() {
      return (
        <Router>
          <Route path="/" render={() => <WrappedComponent {...this.props} />} />
        </Router>
      );
    }
  };
}

export default withRouterV4;
